export const GLOBAL_MODALS = {
  NONE: "none",
  FATAL_ERROR: "fatal error",
  WHATS_NEXT: "what's next",
  SET_REMINDER: "set reminder",
  INVALID_REFERRAL_TOKEN: "invalid referral token"
};
